








































































































































































































import { Vue, Component } from "vue-property-decorator";
import { Bill as IBill } from "@/api/models/bill";
import { BillEdit as IBillEdit } from "@/api/models/bill-edit";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import BillItemPreview from "@/components/bill/BillItemPreview.vue";
import { PaymentCreate as IPaymentCreate } from "@/api/models/payment-create";
import { Contract as IContract } from "@/api/models/contract";
import { Employee as IEmployee } from "@/api/models/employee";
import api from "@/getinfo-api";
import Modal from "@/components/form/Modal.vue";
import { Contractor as IContractor, User as IUser } from "@/api/models";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import BillPaymentForm from "@/components/bill/BillPaymentForm.vue";
import TableActions from "@/components/form/TableActions.vue";
import PaymentsTabbleItem from "@/components/bill/PaymentsTabbleItem.vue";
import { PaymentEdit as IPaymentEdit } from "@/api/models/payment-edit";
import { isAllowEditDates } from "@/plugins/modules-detect";
import { isRoot } from "@/plugins/roles";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { generatePdf } from "@/utils/files-helper";
import store from "@/store";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

@Component({
  components: {
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    TextField,
    CBlock,
    CBreadCrumbs,
    PaymentsTabbleItem,
    TableActions,
    BillPaymentForm,
    CustomButton,
    CustomDatepicker,
    Modal,
    BillItemPreview
  }
})
export default class BillView extends Vue {
  bill!: IBill;
  showPaymentForm: boolean = false;
  value: number = 0;
  customPayments: Array<any> = [];
  contract!: IContract;
  responsibleEmployee!: IEmployee;
  contractor!: IContractor;
  user!: IUser;
  paymentDate!: Date | undefined;
  isLoadingFiles: boolean = false;

  data() {
    return {
      bill: undefined,
      contract: undefined,
      responsibleEmployee: undefined,
      contractor: undefined,
      user: undefined,
      paymentDate: undefined
    };
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  get root() {
    return isRoot();
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "bills" },
        label: this.$tc(this.$translate.Bills)
      },
      {
        label: this.bill.number
      }
    ];
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IBillEdit = {
      contractId: this.bill.contractId,
      number: this.bill.number,
      responsibleId: this.bill.responsibleId!,
      learningResources: this.bill.learningResources,
      formedAt: this.bill.formedAt,
      fileIds:
        this.bill.files && fromDocTemplate
          ? [...this.bill.files.map((el: any) => el.id), ...files]
          : [...files],
      price: this.bill.price
    };

    this.isLoadingFiles = true;

    api.BillApi.edit(this.bill.id, params)
      .then((res: { data: IBill }) => {
        this.bill = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  changeArchiveState(archive: boolean) {
    this.bill.archive = archive;
  }

  getBill() {
    api.BillApi.get(this.$route.params.billId)
      .then((res: { data: IBill }) => {
        this.bill = res.data;
        if (this.bill && !this.contract) {
          this.getContract();
        }
        if (this.bill.payments.length) {
          this.customPaymentObj();
        }
        document.title = `${this.$t(this.$translate.Bill)} ${
          this.bill.number
        } | ${this.companyTitle ?? ""}`;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get companyTitle() {
    return store.getters.selectedCompany.title;
  }

  getContractor() {
    if (this.contract.clientId) {
      api.ContractorApi.get(this.contract.clientId).then(
        (res: { data: IContractor }) => {
          this.contractor = res.data;
        }
      );
    }
  }

  getUser() {
    if (this.contract.clientId) {
      api.UsersApi.get(this.contract.clientId).then((res: { data: IUser }) => {
        this.user = res.data;
      });
    }
  }

  get contractorName() {
    return this.contract?.clientType === "user"
      ? this.user?.fullName
      : this.contractor?.title;
  }

  async getContract() {
    try {
      let responseContract = await api.ContractApi.get(this.bill.contractId);
      this.contract = responseContract.data;
      if (this.bill.responsibleId) {
        let responseResponsible = await api.EmployeeApi.get(
          this.contract.companyId,
          this.bill.responsibleId
        );
        this.responsibleEmployee = responseResponsible.data;
        this.contract.clientType === "user"
          ? this.getUser()
          : this.getContractor();
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    }
  }

  _addPayment(form: IPaymentCreate) {
    if (form.amount > 0) {
      api.BillApi.addPayment(this.bill.id, form)
        .then(() => {
          //@ts-ignore
          this.bill = undefined;
          this.showPaymentForm = false;
          this.value = 0;
          this.customPayments = [];
          this.getBill();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    } else {
      this.$bvToast.toast(`${this.$tc(this.$translate.UnknownError)}`, {
        title: `${this.$tc(this.$translate.Error)}`,
        variant: "danger"
      });
    }
  }

  editPayment(form: any) {
    let params: IPaymentEdit = {
      amount: form.amount,
      paymentAt: form.paymentAt
    };
    api.BillApi.editPayment(this.bill.id, form.paymentId, params).then(() => {
      this.bill = {} as IBill;
      this.showPaymentForm = false;
      this.customPayments = [];
      this.value = 0;
      this.getBill();
    });
  }

  deletePayment(item: string) {
    api.BillApi._delete_1(this.bill.id, item)
      .then(() => {
        //@ts-ignore
        this.bill = undefined;
        this.showPaymentForm = false;
        this.customPayments = [];
        this.value = 0;
        this.getBill();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get sortedPayments() {
    return this.bill.payments?.sort((a, b) => {
      //@ts-ignore
      return new Date(b.paymentAt) - new Date(a.paymentAt);
    });
  }

  customPaymentObj() {
    let arrPaymentsByDate = this.bill.payments
      ?.sort((a, b) => {
        //@ts-ignore
        return new Date(b.paymentAt) - new Date(a.paymentAt);
      })
      .slice()
      .reverse();
    let debt = this.bill.price;

    this.customPayments = arrPaymentsByDate
      .map(item => {
        debt -= item.amount;
        return { item, debt };
      })
      .slice()
      .reverse();
  }

  //Стоимость всех оплат
  get paid() {
    return this.bill.payments.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.amount;
    }, 0);
  }

  // Общий долг (number)
  get debtNumber() {
    return this.bill.price - this.paid;
  }

  styleForDebt(paid: number) {
    return paid >= this.bill.amount ? "full-paid" : "debt";
  }

  checkMaxAmount(value: number) {
    return value > this.$converter.getPrice(this.debtNumber)
      ? this.$converter.getPrice(this.debtNumber)
      : value;
  }

  created() {
    this.getBill();
  }
}
